import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { environment } from '../../../src/environments/environment';
import { NgModule } from '@angular/core';
import { Observable } from 'rxjs';
import {map} from 'rxjs/operators';
@NgModule({

})
// Repository Service
export class RepositoryService {
  private headers: HttpHeaders;
  private headersFile: HttpHeaders;
  private accessPointUrl = environment.backEndApiURL;
  // ctor
  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders(
      {
        'Content-Type': 'application/json; charset=utf-8',
      }
    );
    this.headersFile = new HttpHeaders(
      {

      }
    );
  }

  // Lấy danh sách
  // public getData(serviceName: string, filterRequest: any) {
  //   var paramsData = new HttpParams();
  //   for (let key in filterRequest) {
  //     var value = filterRequest[key];
  //     if (value && key != "constructor")
  //       paramsData = paramsData.set(key, value);
  //   }
  //   var filterObservable = this.http.get<any>(
  //     this.accessPointUrl + serviceName, { headers: this.headers, params: paramsData }
  //   );
  //   return filterObservable;
  // }

  public getData(serviceName: string, filterRequest: any) {
    let paramsData = new HttpParams();
    for (let key in filterRequest) {
        const value = filterRequest[key];
        if (Array.isArray(value)) {
            value.forEach(val => {
                paramsData = paramsData.append(key, val);
            });
        } else if (value && key !== 'constructor') {
            paramsData = paramsData.set(key, value);
        }
    }

    return this.http.get<any>(
        this.accessPointUrl + serviceName,
        { headers: this.headers, params: paramsData }
    );
}


  public getAllData(serviceName: String) {
    var paramsData = new HttpParams();
    var filterObservable = this.http.get<any>(
      this.accessPointUrl + serviceName, { headers: this.headers, params: paramsData }
    );
    return filterObservable;
  }

  public getDataNoKey(serviceName: string, filterRequest: any) {
    var paramsUrl = "";
    for (let key in filterRequest) {
      var value = filterRequest[key];
      if (value && key != "constructor")
        paramsUrl += "/" + value;
    }
    var filterObservable = this.http.get<any>(
      this.accessPointUrl + serviceName + paramsUrl, { headers: this.headers }
    );
    return filterObservable;
  }

  // thêm mới
  public postData(serviceName: string, obj: any) {
    var saveObservable = this.http.post<any>(
      this.accessPointUrl + serviceName, obj, { headers: this.headers }
    );

    return saveObservable;
  }

  // Import file excel
  public postUploadData(serviceName: string, obj: any) {
    var saveObservable = this.http.post<any>(
      this.accessPointUrl + serviceName, obj, { headers: this.headersFile }
    );
    return saveObservable;
  }


  public downloadFile(serviceName, model: any): Observable<HttpEvent<Blob>> {
    const urlApi = this.accessPointUrl + serviceName;
    return this.http.request(new HttpRequest(
      'POST', urlApi,model,
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  // thêm mới file
  public postFileData(serviceName: string, obj: any) {
    var saveObservable = this.http.post<any>(
      this.accessPointUrl + serviceName, obj, { headers: this.headersFile }
    );
    return saveObservable;
  }
  // thêm mới file
  public postFileDataNew(serviceName: string, obj: any) {
    var saveObservable = this.http.post<any>(
        this.accessPointUrl + serviceName, obj,
        { headers: this.headersFile, reportProgress: true, observe: 'events' }
    );
    return saveObservable;
  }

  // sửa
  public putData(serviceName: string, obj: any) {
    var saveObservable = this.http.put<any>(
      this.accessPointUrl + serviceName, obj, { headers: this.headers }
    );

    return saveObservable;
  }

  // xóa
  public deleteData(serviceName: string, id: any) {
    var saveObservable = this.http.delete<any>(
      this.accessPointUrl + serviceName + '?id=' + id, { headers: this.headers }
    );

    return saveObservable;
  }
  public deleteDataNotId(serviceName: string) {
    var saveObservable = this.http.delete<any>(
        this.accessPointUrl + serviceName , { headers: this.headers }
    );

    return saveObservable;
  }
  async getDataAwait(serviceName: string, filterRequest: any) {
    var paramsUrl = "";
    for (let key in filterRequest) {
      var value = filterRequest[key];
      if (value && key != 'constructor')
        paramsUrl += '/' + value;
    }
    return await this.http.get(this.accessPointUrl + serviceName + paramsUrl, { headers: this.headers })
        .toPromise();
  }

}
